var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"botao-cancelar text-capitalize",class:[_vm.textTransform],attrs:{"outlined":"","depressed":"","min-width":"100"},on:{"click":_vm.cancelar}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }